import type { EventType } from '../../types.js'
import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { TextBlock } from '../other/text-block.js'

@jsonClass('ListItemBlock')
export class ListItemBlock extends Block {
	constructor(init: Partial<ListItemBlock> = {}) {
		super()
		this.init(init)
	}
	get allowedEventTypes(): EventType[] {
		return [{ name: 'click' }, { name: 'dblclick' }]
	}

	getEditorCategory(): string {
		return 'Tables & Lists'
	}

	static createNewForEditor(): Block {
		return new this({
			children: [new TextBlock({ text: 'Text' })],
		})
	}
}
